import { useLanguage } from "../i18n";

const Star = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="#F2A33C" aria-hidden="true">
    <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
  </svg>
);

const Marquee = () => {
  const { t } = useLanguage();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div
      className="marquee-wrap relative z-10 -rotate-1 overflow-hidden border-y-2 border-[#F2A33C]/40 bg-[#0D1B2A] py-4"
      data-testid="services-marquee"
    >
      <div className="animate-marquee flex w-max items-center gap-8 pr-8">
        {row.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="flex items-center gap-8 whitespace-nowrap font-serif text-lg italic text-[#FAF6F0]/90 sm:text-xl"
          >
            {item}
            <Star />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
